<template>
  <section class="b b-grey-50 p-4" data-test-id="review-snapshot-rating-breakdown">
    <h3 class="mb-4 title-5">
      {{ $t.ratingBreakdown }}
    </h3>
    <div class="space-y-4">
      <template v-for="{ rating, reviewCount } in ratingHistogram" :key="rating">
        <vf-tooltip class-trigger="grow" placement="top" @click="$emit('filter-by-rating', rating)">
          <template #trigger>
            <div
              class="w-full flex items-center gap-2 rounded-md py-1"
              :class="{ '': ratingFilter === rating }"
            >
              <span class="shrink-0 text-xs" style="text-transform: lowercase">
                {{ rating }} {{ $pluralize($t.stars, rating) }}
              </span>
              <vf-progress-bar class="w-full rounded-xl" :max="reviewsCount" :value="reviewCount" />
              <span class="min-w-8 flex">{{ reviewCount }}</span>
            </div>
          </template>
          {{ replaceAll($t.showOnlyStarReviews, { stars: rating }) }}
        </vf-tooltip>
      </template>
    </div>
  </section>
</template>

<script lang="ts" setup>
defineProps<{
  ratingFilter: number
  ratingHistogram: Array<{ rating: number, reviewCount: number }>
  reviewsCount: number
}>()

defineEmits<{
  'filter-by-rating': [rating: number]
}>()
</script>
